<template>
    <div class="admin mt-3">

        <h1>Admin</h1>

        <b-alert show variant="danger" v-if="!isAdmin">
            Unauthorized
        </b-alert>

        <b-card no-body class="p-0"
                v-else>
            <b-tabs pills card vertical>
                <b-tab title="Classroom Plan Writer">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="Citations">

                                <admin-support-plan-annotations>
                                </admin-support-plan-annotations>

                            </b-tab>
                            <b-tab title="Strategies">

                                <admin-support-plan-strategies>
                                </admin-support-plan-strategies>

                            </b-tab>
                            <b-tab title="Strategy Categories">

                                <admin-support-plan-categories>
                                </admin-support-plan-categories>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
                <b-tab title="DBR Maker">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="Response Formats">

                                <admin-behavior-report-response-formats>
                                </admin-behavior-report-response-formats>

                            </b-tab>
                            <b-tab title="Statements">

                                <admin-behavior-report-statements>
                                </admin-behavior-report-statements>

                            </b-tab>
                            <b-tab title="Help">

                                <admin-help tool-name="behaviorReport">
                                </admin-help>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
                <b-tab title="Progress Monitor">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="Collection Methods">

                                <admin-progress-monitor-collection-methods>
                                </admin-progress-monitor-collection-methods>

                            </b-tab>
                            <b-tab title="Help">

                                <admin-help tool-name="progressMonitor">
                                </admin-help>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
                <b-tab title="ChartDog">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="Help">

                                <admin-help tool-name="chartDog">
                                </admin-help>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
                <b-tab title="Checklist Maker">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="Checklist Items">

                                <admin-checklist-maker-items>
                                </admin-checklist-maker-items>

                            </b-tab>
                            <b-tab title="Help">

                                <admin-help tool-name="checklistMaker">
                                </admin-help>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
                <b-tab title="List Generator">
                    <b-card no-body>
                        <b-tabs pills card>
                            <b-tab title="List Generator Items">

                                <admin-list-generator-items>
                                </admin-list-generator-items>

                            </b-tab>
                            <b-tab title="Help">

                                <admin-help tool-name="listGenerator">
                                </admin-help>

                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-tab>
            </b-tabs>
        </b-card>

    </div>

</template>

<script>
    import Vue from 'vue'
    import AdminListGeneratorItems from "../components/AdminListGeneratorItems";

    export default Vue.extend({
        name: 'admin',
        components: {AdminListGeneratorItems},
        computed: {
            config() {
                return this.$store.state.config
            },
            isAdmin() {
                return this.$store.state.userIsAdmin
            }
        },
        methods: {},
        beforeCreate() {
            this.$api.loadConfig()
        },
        watch: {
            // auto-save config whenever something changes
            '$store.state.config': {
                deep: true,
                handler(newVal, oldVal) {
                    console.log('config watcher')
                    this.$api.debouncedSaveConfig()
                }
            }
        }

    })
</script>

<style lang="scss">

    /* trix styles (rich text editor) */
    button[data-trix-attribute="strike"],
    button[data-trix-attribute="code"],
    button[data-trix-attribute="quote"] {
        display: none;
    }

    trix-editor {
        background-color: #fff;
    }

</style>